import _ from "lodash";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";

import ContractInfo from "@/Components/common/client/contractdetail/ContractInfo";
import {
  toggleOurServiceModal,
  updateactivePages,
} from "@/reducers/clientcommon";
import {
  fetchApplicantLists,
  fetchContractShifts,
  fetchTerminatedShifts,
  setLoading,
  updateActiveContract,
  updateApplicantsPagination,
  updateContractApplicants,
  updateContractShifts,
  updateShiftsPagination,
  updateTerminatedShiftsPagination,
  fetchContractDetailsData,
  setApplicationLoading,
  setShiftLoading,
  setTerminatedLoading,
} from "@/reducers/clientcontractdetail";
import { showManagedServiceToast } from "@/utilities/utils";

import ContractListing from "../../Components/common/client/contractdetail/ContractListing";
import { apiDecrypt } from "../../utilities/keyEncryption";

/**
 * Generates ContractDetail component with session data, contract data, and contract ID.
 *
 * @param {object} data - The contract data object
 * @param {string} contractId - The ID of the contract
 * @param {boolean} contractFound - Flag indicating if the contract is found
 * @return {JSX.Element} The ContractDetail component
 */
const ContractDetail = () => {
  const { id } = useParams();
  const { isPremiumAccount } = useSelector((state) => state.session);
  const {
    applicantsPagination,
    shiftsPagination,
    terminatedShiftsPagination,
    runningLateContract,
    contractId,
    contractDetails,
  } = useSelector((state) => state.clientContractDetail);
  const dispatch = useDispatch();
  // const [data, setData] = useState({});
  // const [runningLateContract, setRunningLate] = useState({});
  // const [contractFound, setContractFound] = useState(true);
  // const [contractId, setContractId] = useState(null);

  // const handleFetchContractDetails = async (contract_id) => {
  //   const response = _fetchContractDetail({ contract_id });
  //   response.then((res) => {
  //     const {
  //       data: {
  //         contract_details,
  //         running_late
  //       }
  //     } = res;
  //     setContractId(contract_id);
  //     setData(contract_details);
  //     setRunningLate(running_late);
  //   }).catch((error) => {
  //     handleAPICatch(error);
  //   })
  // };

  const location = useLocation();

  useEffect(() => {
    const { state } = location;
    if (contractId === null && _.isEmpty(contractDetails)) {
      return;
    }
    dispatch(updateContractShifts([]));
    dispatch(updateContractApplicants([]));
    // dispatch(setContractIdInRedux(contractId));
    // dispatch(updateContractDetails(contractDetails));
    // dispatch(updateRunningLateCandidateContract(runningLateContract));
    dispatch(
      updateApplicantsPagination({
        ...applicantsPagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(
      updateShiftsPagination({
        ...shiftsPagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    dispatch(
      updateTerminatedShiftsPagination({
        ...terminatedShiftsPagination,
        currentPage: 1,
        isLastPage: false,
      }),
    );
    let obj = {
      contract_id: contractId,
    };
    dispatch(setLoading(false));
    dispatch(setApplicationLoading(true));
    dispatch(setShiftLoading(true));
    dispatch(setTerminatedLoading(true));

    dispatch(fetchApplicantLists(obj));
    dispatch(fetchContractShifts(obj));
    if (isPremiumAccount) {
      // added deffault terminated shifts call for self service users only
      dispatch(fetchTerminatedShifts(obj));
    }

    if (state && state?.tab == "terminatedShifts") {
      if (!isPremiumAccount) {
        dispatch(toggleOurServiceModal(true));
        showManagedServiceToast();
        return;
      }
      dispatch(updateActiveContract("terminatedShifts"));
    } else {
      if (
        isPremiumAccount &&
        Array.isArray(runningLateContract) &&
        runningLateContract.length > 0
      ) {
        dispatch(updateActiveContract("runningLateMap"));
      } else if (
        isPremiumAccount &&
        typeof runningLateContract === "object" &&
        runningLateContract !== null &&
        Object.keys(runningLateContract).length > 0
      ) {
        dispatch(updateActiveContract("runningLateMap"));
      } else {
        dispatch(
          updateActiveContract(
            contractDetails.contract_status === "Published"
              ? "shifts"
              : isPremiumAccount
                ? "applicants"
                : "shifts",
          ),
        );
        // }
      }
    }
  }, [contractId]);

  useEffect(() => {
    // alert("1")
    // dispatch(setLoading(true));
    dispatch(
      updateactivePages({
        activePage: null,
        activeSubPage: null,
      }),
    );
    dispatch(fetchContractDetailsData({ contract_id: apiDecrypt(id) }));
    // handleFetchContractDetails(apiDecrypt(id));
  }, [id]);

  return (
    <div className="grid gap-3">
      <ContractInfo />
      <ContractListing _contractID={contractId} />
    </div>
  );
};

export default ContractDetail;
